module.exports = ".button-selected {\n  background-color: rgb(40, 53, 147) !important;\n}\n\n.button-unselected {\n  background-color: #303030 !important;\n}\n\n.sticky {\n  position: sticky;\n  top: 0px;\n  background-color: #000000;\n  z-index: 1000;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-music-library/my-music-library.component.css
// module id = ./src/app/my-music-library/my-music-library.component.css
// module chunks = main